import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UserContext } from '../context/userContext';
// import css from './Drawer.scss';
import get from 'lodash/get';

const gradientStyles = {
  position: 'absolute',
  width: '100%',
  height: '150px',
  top: '-150px',
  backgroundImage:
    'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))'
};

// const templateId = 'OTZW0FG1R04N'; // Piano template ID
// const offerId = 'OF7K5EOM7QWK'; // Piano Offer ID

const loginText = (
  showScreen,
  iframeContainerRef,
  journey,
  height,
  isLoggedIn
) => {
  if (get(iframeContainerRef, 'current', null) !== null && height > 0) {
    if (isLoggedIn) {
      return (
        <div className="drawer__link">
          Please subscribe below to continue reading.
        </div>
      );
    }
    return (
      <div className="drawer__link">
        {get(journey, 'drawerCta', '') === ''
          ? ''
          : `${get(journey, 'drawerCta')}`}
        &nbsp;
        <span
          onClick={e => {
            e.preventDefault();
            showScreen('login', 'modal');
          }}
        >
          Login here
        </span>
      </div>
    );
  }

  return '';
};

const Drawer = ({ open, drawerRef, pageNum, onDrawerFilled }) => {
  const [height, setHeight] = useState(0);
  const [drawerDelivered, setDrawerDelivered] = useState(false);
  const {
    // user,
    // showOffer,
    showScreen,
    journey,
    isLoggedIn
  } = useContext(UserContext);

  // useEffect(() => {
  //   showOffer(
  //     offerId,
  //     templateId,
  //     'inline',
  //     `.drawer`,
  //   );
  // }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!drawerDelivered && drawerRef && drawerRef.current.clientHeight > 0) {
        // Piano has properly served a drawer into this position
        setDrawerDelivered(true);

        // Notify the article component that the drawer has filled
        if (onDrawerFilled) {
          onDrawerFilled();
        }
      }

      if (drawerRef && drawerRef.current.clientHeight !== height) {
        // console.log('🔶 New Drawer height detected', '\n', drawerRef.current.clientHeight);
        setHeight(drawerRef.current.clientHeight);
      }
    }, 250);
    return () => clearInterval(timer);
  });

  return (
    <div
      style={{ height: `${height}px` }}
      className={`drawer__container ${open && `css.open`}`}
    >
      {loginText(showScreen, drawerRef, journey, height, isLoggedIn)}
      {height > 0 && (
        <div className="drawer__gradient" style={gradientStyles} />
      )}
      <div
        id={`drawerHolder-${pageNum}`}
        className="drawer__placeholder"
        ref={drawerRef}
        style={{ zIndex: '999999' }}
      />
    </div>
  );
};

Drawer.defaultProps = {
  open: false,
  drawerRef: {},
  pageNum: 'NI',
  onDrawerFilled: () => {}
};

Drawer.propTypes = {
  open: PropTypes.bool,
  drawerRef: PropTypes.oneOfType([PropTypes.object]),
  pageNum: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onDrawerFilled: PropTypes.func
};

export default Drawer;
